import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';


export default function AttractionCard({image, name, description, onClick}) {

    return (
        <Card sx={{ width: '100%' }} onClick={onClick}>
            <CardMedia
                component="img"
                height="300"
                image={image}
                alt={name}
            />
            <CardContent>
                <Typography variant="h5" component="div">
                    {name}
                </Typography>
                <hr/>
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            </CardContent>
        </Card>
    );
}
